import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'allowphotos',
    pure: true,
    standalone: false
})
export class AllowPhotosPipe implements PipeTransform {
  transform(data: any) {
    return allowPhotos(data);
  }
}

export function allowPhotos(data: any) {
  if (!data) {
    return false;
  }
  if (Array.isArray(data)) {
    return (
      data.length > 0 &&
      data.reduce((prev, current) => current.settings.allowMemoImages && prev, true)
    );
  } else {
    return data.settings && data.settings.allowMemoImages;
  }
}
